import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';

import { switchMap, take } from 'rxjs';
import { AuthenticationService } from '@auth/services/authentication.service';
import { environment } from '../../../environments/environment';

import { HttpInterceptorFn } from '@angular/common/http';

export const GraphqlInterceptor: HttpInterceptorFn = (req, next) => {
  const _authenticationService = inject(AuthenticationService);
  const _oidcSecurityService = inject(OidcSecurityService);
  const graphqlServers = environment.graphql;
  const servers = [
    graphqlServers.wageData.url,
    graphqlServers.project.url,
    graphqlServers.gateway.url,
    graphqlServers.rbs.url,
    graphqlServers.email.url,
  ];

  if (servers.some((server) => req.url.includes(server))) {
    return _authenticationService.isAuthenticated$.pipe(
      take(1),
      switchMap((isAuthenticated) => {
        if (isAuthenticated) {
          return _oidcSecurityService.getAccessToken().pipe(
            switchMap((accessToken) => {
              const modifiedRequest = req.clone({
                setHeaders: {
                  Authorization: `Bearer ${accessToken}`,
                },
              });
              return next(modifiedRequest);
            }),
          );
        } else {
          console.error('User is not authenticated.');
          return next(req);
        }
      }),
    );
  } else {
    return next(req);
  }
};
